module.exports = __webpack_public_path__ + "img/maria.49c8be4c.jpg";